module.exports = __webpack_public_path__ + "img/Steor-Icons-16.883a3228.svg";